import { C, FONTS } from '../../tokens/design';

export default function ScoreGauge({ score, delta }) {
  const s = score ?? 0;
  const d = delta ?? 0;
  const r = 52;
  const circ = 2 * Math.PI * r;
  const f = (s / 100) * (circ * 0.75);
  const col = s >= 80 ? C.grn : s >= 60 ? C.amb : score == null ? C.t3 : C.red;

  return (
    <div style={{ position: 'relative', width: 130, height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width="130" height="110" viewBox="0 0 130 110" style={{ position: 'absolute', top: 0, left: 0 }}>
        <circle cx="65" cy="75" r={r} fill="none" stroke={C.b1} strokeWidth="7"
          strokeDasharray={`${circ * 0.75} ${circ * 0.25}`}
          strokeDashoffset={circ * 0.125} strokeLinecap="round" transform="rotate(180 65 75)" />
        <circle cx="65" cy="75" r={r} fill="none" stroke={col} strokeWidth="7"
          strokeDasharray={`${f} ${circ - f}`}
          strokeDashoffset={circ * 0.125} strokeLinecap="round" transform="rotate(180 65 75)"
          style={{ filter: `drop-shadow(0 0 5px ${col}88)` }} />
      </svg>
      <div style={{ position: 'relative', textAlign: 'center', paddingTop: 8 }}>
        <div style={{ fontSize: 30, fontWeight: 800, color: col, fontFamily: FONTS.mono, lineHeight: 1 }}>{score != null ? s : '\u2014'}</div>
        {d !== 0 && <div style={{ fontSize: 10, color: d >= 0 ? C.grn : C.red, fontFamily: FONTS.mono, marginTop: 1 }}>
          {d >= 0 ? '+' : ''}{d} pts
        </div>}
      </div>
    </div>
  );
}
